import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";
import { isPaymentCardType } from "../utils";

export default function usePaymentChannels() {
  const [transfers, setTransfers] = useState();
  const [cards, setCards] = useState();
  const [banks, setBanks] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const channels = await dataProvider.getList("payment-channels", {
          filter: { status: "Active" },
        });

        const cardsChannels = channels.data.filter((data) =>
          isPaymentCardType(data.payment_method.name)
        );

        const transferChannels = channels.data.filter(
          (data) => data.payment_method.name === "Transfer"
        );
        const banks = await dataProvider.getList("institutes", {
          filter: { status: "Active" },
        });

        setBanks(banks.data);
        setTransfers(transferChannels);
        setCards(cardsChannels);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCardsfromBank = (bankName) => {
    const bank = banks.find((bank) => bank.name === bankName);
    if (!bank) return [];
    const filteredCards = cards.filter((card) => card.institute.id === bank.id);
    return filteredCards;
  };

  const getDefaultCard = () => {
    const filteredCard = cards.find((card) => card.name === "Other");

    return filteredCard;
  };
  const getDefaultBank = () => {
    const filteredBank = banks.find((b) => b.name === "Other");

    return filteredBank;
  };

  return {
    banks,
    cards,
    transfers,
    loading,
    error,
    getCardsfromBank,
    getDefaultCard,
    getDefaultBank,
  };
}
